import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { NegotiationCreatePage } from '@/areas/negotiations/Negotiations/NegotiationCreatePage/NegotiationCreatePage';
import { isInternalUser } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/negotiations/create')({
    staticData: { access: { permissions: isInternalUser }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <NegotiationCreatePage />;
}
